
jQuery(document).ready(function($) {

  $('img[src="https://cdn.marquee.fabapps.co/images/prem_1731516058.png"]').attr('alt', 'Premium League logo');
$('img[src="https://cdn.marquee.fabapps.co/images/spanish_la_liga_logo_2016_1731516202.png"]').attr('alt', 'Spanish La Liga logo ');
$('img[src="https://cdn.marquee.fabapps.co/images/bundesliga_logo_2017svg_1731516163.png"]').attr('alt', 'Bundesliga logo ');
$('img[src="https://cdn.marquee.fabapps.co/images/nwsl_logosvg_1731516140.png"]').attr('alt', 'NWSL logo');
$('img[src="https://cdn.marquee.fabapps.co/images/ncaa_logosvg_1731516120.png"]').attr('alt', 'NCAA logo');
$('img[src="https://cdn.marquee.fabapps.co/images/mls_crest_logo_rgb_gradientsvg_1731516022.png"]').attr('alt', 'MLS crest logo');
$('img[src="https://cdn.marquee.fabapps.co/images/mls_next_logosvg_1731516397.png"]').attr('alt', 'MLS Next logo');
$('img[src="https://cdn.marquee.fabapps.co/images/usys_primary_vert_tm_pms_wbg_1731516413.png"]').attr('alt', 'USYS primary vertical logo');
$('img[src="//themedicaptain.com/cdn/shop/files/header-logo.png?v=1708623126"]').attr('aria-label', 'Medicaptain logo');
$('a[href^="https://www.shopify.com?utm_campaign=poweredby"]').attr('aria-label', 'Powered by Shopify');
$("#SortBy").removeAttr("aria-describedby");
  $("#mobile-SortBy").removeAttr("aria-describedby");
setTimeout(function() {
    $("input.lb-spc-details-checkbox").attr("aria-label", "frequently bought together checkbox");
   $("button.appio-paging-button").append("<span style='display:none'>.</span>");
   $('img[src^="https://cdn.shopify.com/s/files/1/0723/5102/3418/files/1_2_83c50b01-6267-4691-af21-e4d48c3d7ef1_200x200.jpg"]').attr('alt', 'Mini Shin Pad Sleeves with Built-in Shin Guards thumbnail');
$("button.shopify-payment-button__button").append("<span style='display:none'>.</span>");
  $("button.shopify-payment-button__more-options").append("<span style='display:none'>.</span>");
  $('img[src="https://d3ks0ngva6go34.cloudfront.net/public/Keyboard+arrow+up.svg"]').attr('alt', 'right arrow');
$('img[src="https://d3ks0ngva6go34.cloudfront.net/giftBox/medicaptain.myshopify.com/1727452343603.jpg"]').attr('alt', 'Grip socks');
$('img[src="https://d3ks0ngva6go34.cloudfront.net/giftBox/medicaptain.myshopify.com/1727452355838.jpg"]').attr('alt', 'Shin guards');
$('img[src="https://d3ks0ngva6go34.cloudfront.net/giftBox/medicaptain.myshopify.com/1727452404600.jpg"]').attr('alt', 'Pre-cut socks and shin straps');
  $('input[name="filter.v.price.gte"]').attr('aria-label', 'Filter by minimum price');
$('input[name="filter.v.price.lte"]').attr('aria-label', 'Filter by maximum price');
$('div.range-slider > input').attr('aria-label', 'Price range slider');

  $("div.gbbFooterBackButton.gbbDisabled").each(function() {
        var link = $(this);
        var linkText = link.text();
        link.empty().append('<span class="bc">' + linkText + '</span>');
    });
}, 1000);
$("#zoom>img").attr("alt","Zoom exit");
$('img[src="//themedicaptain.com/cdn/shop/files/White_Logo.png?v=1691388701&width=145"]').attr('alt', 'Medicaptain logo in white color');

let Intervaltime_google;
let counter_google = 0; 


try {
    Intervaltime_google = setInterval(GenerateAriaLabelForGoogle, 500);
}
catch (err) {
  
}


function GenerateAriaLabelForGoogle() {
   
    counter_google++;


   
    if ( $('#goog-gt-votingInputSrcLang').length) {
$("label.adb-switch").append('<span style="display:none">.</span>');

$('#goog-gt-votingInputSrcLang').attr('aria-label', 'Source Language');
  $('#goog-gt-votingInputTrgLang').attr('aria-label', 'Target Language');
  $('#goog-gt-votingInputSrcText').attr('aria-label', 'Source Text');
  $('#goog-gt-votingInputTrgText').attr('aria-label', 'Translated Text');
  $('#goog-gt-votingInputVote').attr('aria-label', 'Vote');
      
        clearInterval(Intervaltime_google);
       
    }
    
  
    if (counter_google >= 10) {
        clearInterval(Intervaltime_google);
       
    }
}

console.log( "ready!" );
});